import { render } from "./MoveToGroupModal.vue?vue&type=template&id=9fa026a6"
import script from "./MoveToGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveToGroupModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/MoveToGroupModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9fa026a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9fa026a6', __exports__)) {
    api.reload('9fa026a6', __exports__)
  }
  
  module.hot.accept("./MoveToGroupModal.vue?vue&type=template&id=9fa026a6", () => {
    api.rerender('9fa026a6', render)
  })

}


export default __exports__